/*
 *
 * Package: `@dbh/app`.
 *
 */const importApp=import('./component-fa6d8477.js'/*  webpackChunkName: 'dbh.app.component' */);const importAppReducersAndSagas=import('./reducers-and-sagas-f376821c.js'/*  webpackChunkName: 'dbh.app.reducers-and-sagas' */);

export { importApp, importAppReducersAndSagas };
